<template>
    <div>
        <config-main-title>
            Autorizar Máquina
        </config-main-title>

        <template v-if="maquinas">
        
            <div class="mb-3">
                <az-input
                    placeholder="Informe um nome para essa máquina... (contendo apenas letras e números)..."
                    v-model="nome"
                    :validate="validate">
                    <template v-slot:buttonposb>
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-primary" v-if="!valido || !chave" @click="gerar()">Gerar</button>
                            <div class="input-group-append" v-else-if="valido">
                                <span class="input-group-text" id="basic-addon2">
                                    <i class="fa fa-check text-success" aria-hidden="true"></i>
                                </span>
                            </div>
                        </div>
                    </template>
                </az-input>
            </div>

            <ul class="list-group">
                <li class="list-group-item" :class="valido && maquina == validacao.maquina ? 'active' : ''" v-for="(maquina, imx) in maquinas" :key="imx">
                    <button type="button" class="btn btn-sm mr-2" 
                        :class="valido && maquina == validacao.maquina ? 'btn-danger' : 'btn-outline-danger'" 
                        @click="remover(maquina)">
                        <i class="fas fa-trash-alt"></i>
                    </button>
                    {{ maquina }}
                </li>
            </ul>

            <p class="alert alert-info mt-3">
                Recurso para autorizar essa máquina para usuários que só podem acessar o sistema em máquinas autorizadas.<br><br>
                Deve ser informado um nome para máquina e clicado no botão gerar, pra que seja gerada a autorização de acesso nessa máquina.<br><br>
                No cadastro do usuário, deve ser indicado que ele tem acesso somente em máquinas autorizadas.
            </p>

        </template>

    </div>
</template>

<script>
import AzInput from '../../shared/forms/AzInput.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';

export default {
    data() { 
        return { 
            maquinas: null,
            nome: "",
            chave: "", 
            validacao: null, 
            validate: false, 
        }
    },
    
    components: { 
        AzInput, 
        ConfigMainTitle,
    },

    computed: { 
        valido: function () { 
            return this.validacao && this.validacao.maquina == this.nome;
        }
    },

    methods: { 
        gerar() { 
            this.$util.atualizar(this, { 
                service: 'fingerprints',
                func: 'gerar',
                dados: { 
                    nome: this.nome, 
                },
                callback: res => { 
                    this.$util.setCookie('maquina', res.maquina, 9999);
                    this.$util.setCookie('maquina.' + res.maquina, res.chave, 9999);
                },
                reload: true, 
                toast: true, 
            });
        },

        remover(maquina) { 
            this.$util.atualizar(this, { 
                service: 'fingerprints',
                func: 'remover',
                dados: { 
                    nome: maquina, 
                },
                callback: () => { 
                    this.load();
                }
            });

        },

        load() { 
            this.$util.load(this, { 
                service: 'fingerprints',
                func: 'listar',
                loadTo: res => { 
                    this.maquinas = res;
                    this.validar();
                }
            });
        },

        validar() { 

            if ( this.nome ) { 

                this.chave = this.$util.getCookie('maquina.' + this.nome);

                this.$util.loadItem(this, { 
                    service: 'fingerprints',
                    func: 'validar',
                    parms: { 
                        nome: this.nome,
                        chave: this.chave,
                    }
                })
                .then(res => { 
                    this.validacao = res;
                });

            }

        }
    },

    mounted() { 

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Autorizar Máquina" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.nome = this.$util.getCookie('maquina');

        this.$util.valid_permissao(this, 88, this.load);

    },
}
</script>